import { useRouter } from 'next/router'

// 入口开放的route
const pathConfig = ['/home', '/new_home']

export default function useShouldShowEntrance() {
  const router = useRouter()
  // 只展示首页 /new_home
  return pathConfig.indexOf(router?.route) >= 0
}
